const onRebuyCallback = async (event) => {
  var data = event.detail.product;
  const cartDrawer = document.querySelector('cart-drawer');
  const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
  const cartSections = await fetch(window.Shopify.routes.root + `?sections=${cartDrawer.dataset.sectionId}`).then(res => res.json());
  cartJson['sections'] = cartSections;

  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: data,
      },
    })
  );
  cartDrawer.show();
  Rebuy.Cart.fetchCart();
};

document.addEventListener('rebuy.add', onRebuyCallback);
document.addEventListener('rebuy.remove', onRebuyCallback);
document.addEventListener('rebuy.change', onRebuyCallback);